<template lang="pug">

    .account-list
        .p-title 消费记录
        .p-main
            el-table(:data="tableData" size="mini" stripe border height="100%")
                el-table-column(type="" width="" align="center" prop="createTime")
                    template(slot="header" slot-scope="{row}")
                        span 日期
                        i.iconfont.icon-shaixuan(@click="showPicker")
                        el-date-picker(
                            v-model="pickerDate"
                            type="datetimerange"
                            align="left"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions2"
                            ref="datePicker"
                            @change="dateChange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                        )
                el-table-column(type="" width="" label="类型" align="center" prop="optDetailName")
                el-table-column(type="" width="" label="金额" align="center")
                    template(slot-scope="{row}") - {{row.amount ? row.amount.toFixed(2) : '0.00'}}元
                
            Pagination.page_box(
                :total="pageInfo.total" :current-page.sync="pageInfo.current"
                :size.sync="pageInfo.size" @fn-change="getList"
            )

</template>

<script>
import Pagination from '../components/Pagination'
export default {
    name: 'spent-list',
    components: { Pagination },
    data () {
        return {
            tableData: [
                // {
                //     date: '2018年11月09日-11月10日（共2天）',
                //     type: '08:00-08:30；09:00-09:30；14:00-14:30；14:30-15:00',
                //     amount: 200000
                // }
            ],
            pageInfo: {
                total: 0,
                current: 1,
                size: 20
            },
             pickerOptions2: {
                onPick(data, b) {
                    ;[...document.getElementsByClassName('el-picker-panel__shortcut color')].forEach(el => {
                        el.className = 'el-picker-panel__shortcut'
                    })
                    if(data.maxDate) data.maxDate = new Date(data.maxDate.getTime() + 24*3600000 - 1000)
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const td = new Date().setHours(0,0,0,0);
                        picker.$emit('pick', [new Date(td), new Date()]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const td = new Date().setHours(0,0,0,0);
                        const start = new Date();
                        start.setTime(td - 3600 * 1000 * 24);
                        picker.$emit('pick', [start, new Date(td - 1000)]);
                    }
                }, {
                    text: '过去7天',
                    onClick(picker) {
                        const tdZero = new Date().setHours(0,0,0,0);
                        picker.$emit('pick', [new Date(tdZero - 3600 * 1000 * 24 * 7), new Date(tdZero - 1000)]);
                    }
                }, {
                    text: '本月',
                    onClick(picker) {
                        const td = new Date();
                        picker.$emit('pick', [new Date(td.getFullYear() + '-' + (td.getMonth()+1) + '-01 00:00:00'), td]);
                    }
                }, {
                    text: '上个月',
                    onClick(picker) {
                        const td = new Date();
                        let month = td.getMonth()
                        let start
                        if (month == 0) {
                            start = new Date( td.getFullYear() - 1 + '-12-01 00:00:00' );
                        } else {
                            start = new Date( td.getFullYear() + '-' + td.getMonth() + '-01 00:00:00' );
                        } 
                        let end = new Date( td.getFullYear() + '-' + (td.getMonth()+1) + '-01 00:00:00' ).getTime() - 1000;
                        picker.$emit('pick', [start, new Date(end)])
                    }
                }
                ]
            },
            pickerDate: null,
            startTimeStr: '',
            endTimeStr: ''
        }
    },
    created(){
        this.getList()
    },
    methods: {
        showPicker(){
            this.$refs.datePicker.focus()
            setTimeout(()=>{
                ;[...document.getElementsByClassName('el-picker-panel__shortcut')].forEach(element => {
                    element.addEventListener('click', function(){
                        ;[...document.getElementsByClassName('el-picker-panel__shortcut color')].forEach(el => {
                            el.className = 'el-picker-panel__shortcut'
                        })
                        element.className = element.className + ' color';
                    })
                });
            }, 300)
        },
        dateChange(){
            this.pageInfo.current = 1
            if(!this.pickerDate) {
                this.startTimeStr = ''
                this.endTimeStr = ''
                ;[...document.getElementsByClassName('el-picker-panel__shortcut color')].forEach(el => {
                    el.className = 'el-picker-panel__shortcut'
                })
            }else {
                let isLeftClick = [...document.getElementsByClassName('el-picker-panel__shortcut color')].length > 0
                this.startTimeStr = this.pickerDate[0]
                this.endTimeStr = isLeftClick ? this.pickerDate[1] : this.pickerDate[1].slice(0, 10) + ' 23:59:59'
                // this.endTimeStr = this.pickerDate[1]
            }
            this.getList()
        },
        async getList () {
            let option = {
                // accountType: '',     // 1 现金账户    2 赠款账户
                optType: 2,    // 1 充值   2 消费
                pageIndex: this.pageInfo.current,
                pageSize: this.pageInfo.size
            }
            if(this.startTimeStr) option.startTimeStr = this.startTimeStr
            if(this.endTimeStr) option.endTimeStr = this.endTimeStr
            let res = await this.fetch('/boss/accounthistory/v2/queryAccountHistoryPage', option)
            if(res && res.code == this.successCode) {
                this.tableData = res.data.list || []
                this.pageInfo.total = res.data.total || 0
            }
        }
    },
    mounted(){
        document.body.className = 'account-list-page'
    },
    beforeDestroy(){
        document.body.className = ''
    }
}
</script>

<style lang="sass">
.account-list-page 
    .p-main
        position: relative
        padding: 20px 20px 0
        padding-bottom: 59px
        ::v-deep .el-table
            border-top: none
            height: 100%
            .el-table__header
                background: #F1F1F1
                .cell
                    border-right: 1px solid #D4D4D4
                    color: #282729
                .is-leaf
                    border-right: none
                    background: #F1F1F1
            .el-table__row
                td
                    padding: 10px 0
        .page_box
            position: absolute
            width: calc(100% - 40px)
            height: 60px
            padding: 10px 20px
            bottom: 0
            border: 1px solid #E9E9E9
            left: 20px
    .row_order
        .order_no
            background: rgba(255, 57, 115, 0.1)
            line-height: 30px
            color: #282729
        .time
            color: #282729
            font-weight: 600
        .color_999
            color: #999
</style>

